import { useTranslation } from "react-i18next";
import { Download, Search } from "lucide-react";
import { NeuInput } from "../../../components/neu/Neu";
import { exportCsv } from "./exportRows";

// Search box, optional filter chips and CSV export for a detail table.
export const DetailToolbar = ({ detail, state, section }) => {
  const { t } = useTranslation();
  const { rows, query, setQuery, filter, setFilter } = state;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative min-w-[200px] flex-1">
        <Search className="absolute inset-y-0 start-3 my-auto h-4 w-4 text-muted-foreground" />
        <NeuInput
          className="ps-9 text-xs"
          data-testid="detail-search"
          placeholder={t("system.searchPlaceholder")}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {(detail.filters || []).map((f) => (
        <button
          key={f.key}
          type="button"
          data-testid={`detail-filter-${f.key}`}
          onClick={() => setFilter(f.key === filter ? "all" : f.key)}
          className={`rounded-2xl px-3 py-2 text-xs font-bold shadow-neu-sm transition-[box-shadow] duration-300 ${
            f.key === filter ? "text-primary shadow-neu-in" : "text-muted-foreground"
          }`}
        >
          {f.label}
        </button>
      ))}

      <button
        type="button"
        data-testid="detail-export"
        onClick={() => exportCsv(section, detail.columns, rows)}
        className="flex items-center gap-2 rounded-2xl px-3 py-2 text-xs font-bold text-primary shadow-neu-sm transition-[box-shadow] duration-300 hover:shadow-neu-in"
      >
        <Download className="h-4 w-4" /> {t("system.exportCsv")}
      </button>
    </div>
  );
};
